export default function Pagination({ currentPage, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  const safeCurrentPage = Math.max(1, Math.min(currentPage, totalPages));
  const canGoPrev = safeCurrentPage > 1;
  const canGoNext = safeCurrentPage < totalPages;

  const buildPageItems = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    const items = [1];
    const start = Math.max(2, safeCurrentPage - 1);
    const end = Math.min(totalPages - 1, safeCurrentPage + 1);

    if (start > 2) items.push("left-ellipsis");

    for (let page = start; page <= end; page += 1) {
      items.push(page);
    }

    if (end < totalPages - 1) items.push("right-ellipsis");
    items.push(totalPages);

    return items;
  };

  const pageItems = buildPageItems();
  const handleChange = (nextPage) => {
    if (nextPage < 1 || nextPage > totalPages || nextPage === safeCurrentPage) return;
    onChange(nextPage);
  };

  return (
    <nav>
      <ul className="pagination">
        <li className={`page-item ${!canGoPrev ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => handleChange(safeCurrentPage - 1)}
            disabled={!canGoPrev}
            aria-label="Previous page"
          >
            Previous
          </button>
        </li>

        {pageItems.map((item, index) =>
          typeof item === "number" ? (
            <li
              key={item}
              className={`page-item ${safeCurrentPage === item ? "active" : ""}`}
            >
              <button className="page-link" onClick={() => handleChange(item)}>
                {item}
              </button>
            </li>
          ) : (
            <li key={`${item}-${index}`} className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          )
        )}

        <li className={`page-item ${!canGoNext ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => handleChange(safeCurrentPage + 1)}
            disabled={!canGoNext}
            aria-label="Next page"
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
}
